import AsyncStorage from '@react-native-async-storage/async-storage';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { createTransform, persistCombineReducers, persistStore, } from 'redux-persist';
import getStoredStateMigrateV4 from 'redux-persist/lib/integration/getStoredStateMigrateV4';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import startupSaga from 'sagas';
import { initialState as initialCreditScoreState, } from 'features/credit-score/reducers/creditScore';
import { initialState as initialSpacesState, } from 'features/spaces/reducers/spaces';
import { initialState as initialUserState } from 'reducers/user';
import { initialState as initialDeviceSettingsState } from 'reducers/deviceSettings';
import { YEARLY_REPORT_FEED, } from 'actions/deviceSettingTypes';
import { isWeb } from '../constants';
import { analyticsMiddleware } from '../middleware/analytics';
import { apiMiddleware } from '../middleware/api';
import { errorMiddleware } from '../middleware/error';
import reducers from '../reducers';
import { setReduxStore } from './storeRegistry';
const isDebuggingInChrome = __DEV__ && !!window.navigator?.userAgent;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = createLogger({
    predicate: () => isDebuggingInChrome,
    collapsed: true,
    duration: true,
});
const saga = createSagaMiddleware();
const middlewares = [
    thunk,
    apiMiddleware,
    analyticsMiddleware,
    errorMiddleware,
    saga,
];
const webWhitelist = [
    'spaces',
    'user',
    'deviceSettings',
    'creditScore',
];
const config = {
    whitelist: isWeb
        ? Array.from(webWhitelist)
        : [
            'addressReducer',
            'accounts',
            'user',
            'feed',
            'utils',
            'payments',
            'spaces',
            'stripe',
            'beneficiaries',
            'invest',
            'pots',
            'contacts',
            'deviceSettings',
            'analytics',
            'signInNavigation',
            'rentReporting',
            'quests',
            'budgeting',
            'paymentLimits',
            'iapSubscriptions',
            'referrals',
            'preApprovedTransfers',
            'smartRules',
            'groups',
            'paymentsV2',
            'walkthrough',
            'dataProtection',
            'helpArticles',
            'setUpEmma',
            'creditScore',
            'creditReport',
            'enhancedFactors',
            'creditAlerts',
            'creditScoreHistory',
        ],
    storage: AsyncStorage,
    ...(isWeb && {
        transforms: [
            createTransform((state, key) => {
                const { key: k, state: s } = {
                    key,
                    state,
                };
                switch (k) {
                    case 'spaces':
                        return {
                            selectedSpace: s.selectedSpace,
                        };
                    case 'user':
                        return {
                            user: {
                                guessedHomeCountry: s.user?.guessedHomeCountry,
                            },
                            ignoredCloseConnectionPrompts: s.ignoredCloseConnectionPrompts,
                            lastSession: s.lastSession,
                        };
                    case 'deviceSettings':
                        return {
                            hideScrambleModal: s.hideScrambleModal,
                            didViewFraudDetectionIntro: s.didViewFraudDetectionIntro,
                            didViewTrueBalanceIntro: s.didViewTrueBalanceIntro,
                            didSetPeriod: s.didSetPeriod,
                            lastTimeDismissCreditScoreRealTimeUpsell: s.lastTimeDismissCreditScoreRealTimeUpsell,
                            [YEARLY_REPORT_FEED]: s[YEARLY_REPORT_FEED],
                        };
                    case 'creditScore':
                        return {
                            status: s.status,
                            data: s.data,
                            lastSeenScore: s.lastSeenScore,
                        };
                    default: {
                        const _ = k;
                        return s;
                    }
                }
            }, (state, key) => {
                const { key: k, state: s } = {
                    key,
                    state,
                };
                switch (k) {
                    case 'spaces':
                        return { ...initialSpacesState, ...s };
                    case 'user':
                        return {
                            ...initialUserState,
                            ...s,
                            user: {
                                ...initialUserState.user,
                                ...s.user,
                            },
                        };
                    case 'deviceSettings':
                        return { ...initialDeviceSettingsState, ...s };
                    case 'creditScore':
                        return { ...initialCreditScoreState, ...s };
                    default: {
                        const _ = k;
                        return s;
                    }
                }
            }, { whitelist: Array.from(webWhitelist) }),
        ],
    }),
};
const createEMMAStore = applyMiddleware(...middlewares)(createStore);
const rootReducer = persistCombineReducers({
    // @ts-expect-error
    getStoredState: getStoredStateMigrateV4(config),
    key: 'primary',
    ...config,
}, reducers);
function configureStore() {
    const store = createEMMAStore(rootReducer, undefined, 
    // @ts-expect-error TODO fix
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
    const persistor = persistStore(store, null);
    setReduxStore(store);
    if (isDebuggingInChrome) {
        window.store = store;
    }
    saga.run(startupSaga);
    return { store, persistor };
}
export default configureStore;
